<!-- ================科学艺术馆-恒岳科创会活动详情====================-->
<template>
    <div class="technology-offline-info-container">
        <home-head />
        <div class="technology-offline-info-body">
            <div class="technology-offline-info-inner">
                <!-- 顶部标题栏 -->
                <div class="technology-offline-info-header">
                    <div class="back-btn" @click="goBack">
                        <span class="back-arrow">←</span>
                        <span>返回</span>
                    </div>
                    <div class="technology-offline-info-title">{{ activityForm.activityName || '详情' }}</div>
                    <div class="technology-offline-info-actions">
                        <div class="action-btn" :class="{ active: isFavorite }" @click="handleFavorite" title="收藏">
                            <svg viewBox="0 0 1024 1024" width="22" height="22">
                                <path d="M512 0l127.4 395.6H1024L639.3 640.4 766.7 1024 512 779.6 257.3 1024l127.4-383.6L0 395.6h384.6z" fill="currentColor"/>
                            </svg>
                        </div>
                        <div class="action-btn" :class="{ active: isLike }" @click="handleLike" title="点赞">
                            <svg viewBox="0 0 1024 1024" width="22" height="22">
                                <path d="M884.2 396.6c-18.4-22.9-46.5-36.6-76.7-36.6h-188l21.6-117.8c8.6-46.8-3.8-95.4-34-132.4-28.2-34.6-69.8-54.4-113.8-54.4-54.2 0-102.8 31.4-125.6 80.4L299.6 270.2c-10.2 22.6-12.4 48.2-6.2 72.4l35.8 142.2H180.8c-56.8 0-102.8 46-102.8 102.8v281.2c0 56.8 46 102.8 102.8 102.8h532.4c48.2 0 90.8-31.8 104.4-78.4l102.6-360.6c12.6-44.2-1.6-91.8-34.6-124.6zM235.2 868.6h-54.4v-281.2h54.4v281.2z" fill="currentColor"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <!-- 主内容区 -->
                <div class="technology-offline-info-main">
                    <!-- 左侧详情 -->
                    <div class="technology-offline-info-left">
                        <!-- 活动信息 -->
                        <div class="info-row">
                            <span class="info-label">活动主题：</span>
                            <span class="info-value">{{ activityForm.activityName || '-' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">所属主题：</span>
                            <span class="info-value">{{ activityForm.activityItemName || '-' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">学段年级：</span>
                            <span class="info-value">{{ activityForm.periodName }}{{ activityForm.activityGradeName ? '·' + activityForm.activityGradeName : '' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">活动时长：</span>
                            <span class="info-value">{{ activityForm.activityTime || '-' }}</span>
                        </div>

                
                        <!-- 活动准备 -->
                        <div class="info-section" v-if="activityForm.activityDesc">
                            <div class="section-label">活动说明：</div>
                            <div class="info-content" style="white-space: pre-wrap;">{{ activityForm.activityDesc }}</div>
                        </div>

                        <!-- 活动流程 -->
                        <div class="info-section" v-if="activityForm.activityAim">
                            <div class="section-label">活动目标：</div>
                            <div class="info-content" style="white-space: pre-wrap;">{{ activityForm.activityAim }}</div>
                        </div>

                        <!-- 活动附件 -->
                        <div class="info-section">
                            <div class="section-label">活动附件：</div>
                            <div class="file-list" v-if="fileList && fileList.length > 0">
                                <div class="file-item" v-for="(item, index) in fileList" :key="index">
                                    <div class="file-name">{{ item.fileName }}</div>
                                    <div class="file-actions">
                                        <div class="file-action view" v-if="judgeIsPPT(item.fileType)" @click="viewPPTFile(item.fileUrl)" title="预览">
                                            <img src="@/assets/file/ppt_play.png" alt="预览" />
                                        </div>
                                        <div class="file-action download" @click="downloadFile(item)" title="下载">
                                            <img src="@/assets/file/file_download.png" alt="下载" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="no-file" v-else>暂无附件</div>
                        </div>
                    </div>

                    <!-- 右侧封面与评论 -->
                    <div class="technology-offline-info-right">
                        <div class="section-label">活动封面：</div>
                        <div class="technology-offline-info-cover">
                            <img :src="activityForm.activityCover" alt="活动封面" />
                        </div>

                        <!-- 评论区 -->
                        <div class="comment-section">
                            <div class="comment-title">评论区</div>
                            <div class="comment-input-box">
                                <el-input
                                    type="textarea"
                                    :rows="3"
                                    resize="none"
                                    placeholder="请输入内容"
                                    v-model="discussWordContent"
                                />
                            </div>
                            <div class="comment-toolbar">
                                <el-upload
                                    class="comment-uploader"
                                    :action="serviceUrl + '/businessservice/event/uploadFile'"
                                    :show-file-list="false"
                                    :on-success="handleUploadImageSuccess"
                                    :headers="{ token }"
                                    accept=".png,.jpeg,.jpg"
                                    :before-upload="beforeImageUpload"
                                >
                                    <img class="upload-icon" src="@/assets/image/upload_img1.png" alt="上传图片" />
                                </el-upload>
                                <div class="submit-btn" @click="submitDiscuss">发表</div>
                            </div>

                            <!-- 评论列表 -->
                            <div class="comment-list" v-if="discussList && discussList.length > 0">
                                <div class="comment-item" v-for="(item, index) in discussList" :key="index">
                                    <div class="comment-avatar">
                                        <img :src="item.avatar" alt="头像" @error="onImageError" />
                                    </div>
                                    <div class="comment-content">
                                        <div class="comment-meta">
                                            <span class="comment-user">{{ item.createUserName }}</span>
                                            <span class="comment-time">{{ timestampToTime(item.createTime) }}</span>
                                        </div>
                                        <div class="comment-text" v-if="item.discussType === 1">{{ item.content }}</div>
                                        <div class="comment-image" v-if="item.discussType === 2">
                                            <el-image :src="item.imgContent" :preview-src-list="item.imgList" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="comment-empty" v-else>
                                <div class="empty-icon">
                                    <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                                </div>
                                <div class="empty-text">暂无数据</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { infoMuseumActivity } from "@/api/admin/museumActivity";
import { addOrCancelCollect, judgeIsCollect } from "@/api/admin/collect";
import { addOrCancelLike, judgeIsLike } from "@/api/admin/likes";
import { serviceUrl } from "@/utils/global";
import { timestampToTime } from "@/utils/date";
import { downloadFile } from "@/utils/download";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "technologyOfflineInfo",
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            activityId: "",
            activityForm: {},
            fileList: [],
            discussList: [],
            discussWordContent: "",
            discussType: 1,
            imgContent: "",
            isFavorite: false,
            isLike: false,
            timestampToTime,
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.activityId) {
            this.activityId = this.$route.query.activityId;
            this.queryActivityInfo();
            this.queryCollectStatus();
            this.queryLikeStatus();
        }
    },
    mounted() {},
    methods: {
        /* ===============查询活动详情===================== */
        queryActivityInfo() {
            infoMuseumActivity({ activityId: this.activityId }).then(res => {
                if (res.data.code === 1) {
                    this.activityForm = res.data.data || {};
                    this.fileList = this.activityForm.fileList || [];
                    this.discussList = this.activityForm.discussList || [];
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            });
        },
        /* ===============返回===================== */
        goBack() {
            this.$router.go(-1);
        },
        /* ===============收藏/点赞===================== */
        queryCollectStatus() {
            judgeIsCollect({ relationId: this.activityId, collectType: 4, businessType: 2 }).then(res => {
                if (res.data.code === 1) {
                    this.isFavorite = !!res.data.data;
                }
            });
        },
        queryLikeStatus() {
            judgeIsLike({ relationId: this.activityId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !!res.data.data;
                }
            });
        },
        handleFavorite() {
            addOrCancelCollect({ relationId: this.activityId, collectType: 4, businessType: 2 }).then(res => {
                if (res.data.code === 1) {
                    this.isFavorite = !this.isFavorite;
                    this.$message.success(this.isFavorite ? "收藏成功" : "已取消收藏");
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            });
        },
        handleLike() {
            addOrCancelLike({ relationId: this.activityId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !this.isLike;
                    this.$message.success(this.isLike ? "点赞成功" : "已取消点赞");
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            });
        },
        /* ===============核心读物跳转===================== */
        handleBookClick(item) {
            this.$router.push({
                path: "/museum/read/bookInfo",
                query: { bookId: item.bookId },
            });
        },
        /* ===============文件操作===================== */
        judgeIsPPT(fileType) {
            if (!fileType) return false;
            return fileType.toLowerCase().includes("ppt");
        },
        viewPPTFile(fileUrl) {
            const openUrl = "https://ow365.cn/?i=36735&ssl=1&furl=" + fileUrl;
            window.open(openUrl, "_blank");
        },
        downloadFile(item) {
            downloadFile(item.fileUrl, item.fileName);
        },
        /* ===============评论区===================== */
        handleUploadImageSuccess(res) {
            if (res.code === 1) {
                this.discussType = 2;
                this.imgContent = res.data;
                this.submitDiscuss();
            } else {
                this.$message.error(res.msg || "上传失败");
            }
        },
        beforeImageUpload(file) {
            const isImage = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
            if (!isImage) {
                this.$message.error("请上传 JPG/PNG 格式的图片");
            }
            return isImage;
        },
        submitDiscuss() {
            if (!this.discussWordContent && !this.imgContent) {
                this.$message.warning("请输入评论内容");
                return;
            }
            // 评论提交接口需后端提供，此处为占位演示
            this.$message.success("评论提交成功（演示）");
            this.discussWordContent = "";
            this.imgContent = "";
            this.discussType = 1;
        },
        onImageError(e) {
            e.target.src = require("@/assets/image/data_empty.png");
        },
    }
}
</script>

<style scoped>
.technology-offline-info-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.technology-offline-info-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 20px 0 10px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.technology-offline-info-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 顶部标题栏 */
.technology-offline-info-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
    position: relative;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 22px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

.back-arrow {
    margin-right: 6px;
    font-size: 16px;
}

.technology-offline-info-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 22px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
}

.technology-offline-info-actions {
    display: flex;
    align-items: center;
    gap: 14px;
}

.action-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9ca3af;
    cursor: pointer;
    transition: all 0.2s ease;
}

.action-btn:hover,
.action-btn.active {
    color: #b22222;
}

/* 主内容区 */
.technology-offline-info-main {
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    gap: 30px;
    overflow: hidden;
}

.technology-offline-info-left {
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow-y: auto;
    padding-right: 10px;
    box-sizing: border-box;
}

.technology-offline-info-right {
    width: 260px;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-right: 10px;
    box-sizing: border-box;
}

.technology-offline-info-left::-webkit-scrollbar,
.technology-offline-info-right::-webkit-scrollbar {
    width: 6px;
}

.technology-offline-info-left::-webkit-scrollbar-thumb,
.technology-offline-info-right::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
}

/* 通用标签与内容 */
.section-label,
.info-label {
    font-size: 16px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    flex-shrink: 0;
}

.info-row {
    display: flex;
    align-items: baseline;
    font-size: 15px;
    line-height: 2;
    font-family: sans-serif;
}

.info-label {
    margin-right: 6px;
}

.info-value {
    color: #1f2937;
}

.info-section {
    margin-top: 16px;
}

.info-content {
    font-size: 15px;
    color: #374151;
    line-height: 1.8;
    font-family: sans-serif;
    text-align: justify;
    padding-left: 2px;
}

/* 核心读物 */
.event-book-list {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
}

.event-book-item {
    width: 120px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.25s ease;
}

.event-book-item:hover {
    transform: translateY(-4px);
}

.event-book-cover {
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 6px;
    background-color: #f3f4f6;
    border-radius: 4px;
}

.event-book-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.event-book-name {
    width: 100%;
    font-size: 13px;
    color: #1f2937;
    font-family: sans-serif;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 附件 */
.file-list {
    margin-top: 8px;
}

.file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.file-name {
    font-size: 15px;
    color: #1f2937;
    font-family: sans-serif;
}

.file-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.file-action {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.file-action img {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.no-file {
    font-size: 14px;
    color: #9ca3af;
    padding: 10px 0;
}

/* 右侧封面 */
.technology-offline-info-cover {
    width: 100%;
    height: 180px;
    margin-top: 8px;
    margin-bottom: 16px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #f3f4f6;
    border-radius: 4px;
}

.technology-offline-info-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* 评论区 */
.comment-section {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.comment-title {
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    border-left: 4px solid #b22222;
    padding-left: 8px;
    margin-bottom: 12px;
}

.comment-input-box {
    width: 100%;
}

.comment-input-box :deep(.el-textarea__inner) {
    font-size: 14px;
    font-family: sans-serif;
}

.comment-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 16px;
}

.comment-uploader {
    width: 30px;
    height: 30px;
    cursor: pointer;
}

.upload-icon {
    width: 30px;
    height: 30px;
    object-fit: contain;
}

.submit-btn {
    height: 30px;
    line-height: 30px;
    padding: 0 22px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 15px;
    font-size: 13px;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}

.submit-btn:hover {
    background-color: #9a1b1b;
}

/* 评论列表 */
.comment-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-right: 4px;
}

.comment-list::-webkit-scrollbar {
    width: 4px;
}

.comment-list::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 2px;
}

.comment-item {
    display: flex;
    gap: 10px;
    padding: 12px 0;
    border-bottom: 1px solid #f3f4f6;
}

.comment-avatar {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
}

.comment-avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}

.comment-content {
    flex: 1;
    min-width: 0;
}

.comment-meta {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
}

.comment-user {
    font-size: 13px;
    color: #377f7f;
    font-weight: bold;
}

.comment-time {
    font-size: 12px;
    color: #9ca3af;
}

.comment-text {
    font-size: 13px;
    color: #4b5563;
    line-height: 1.6;
    word-break: break-all;
}

.comment-image {
    margin-top: 6px;
}

.comment-image :deep(.el-image img) {
    max-width: 160px;
    max-height: 160px;
    border-radius: 4px;
    cursor: pointer;
}

/* 评论为空 */
.comment-empty {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
}

.comment-empty .empty-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
}

.comment-empty .empty-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.comment-empty .empty-text {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
}

@media (max-width: 1024px) {
    .technology-offline-info-main { flex-direction: column; overflow-y: auto; }
    .technology-offline-info-left { width: 100%; height: auto; overflow: visible; }
    .technology-offline-info-right { width: 100%; height: auto; overflow: visible; flex-direction: row; flex-wrap: wrap; }
    .technology-offline-info-cover { width: 200px; margin-right: 30px; }
    .comment-section { flex: 1; min-width: 280px; }
    .technology-offline-info-title { font-size: 18px; }
}

@media (max-width: 768px) {
    .technology-offline-info-header { flex-wrap: wrap; gap: 10px; }
    .technology-offline-info-title { position: static; transform: none; order: 3; width: 100%; text-align: center; margin-top: 10px; }
    .technology-offline-info-right { flex-direction: column; }
    .technology-offline-info-cover { width: 100%; margin-right: 0; }
}
</style>
